import { Button } from 'antd';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { getQueryString } from '@sonar-software/sonar-http';
import { Link } from 'react-router-dom';
import React from 'react';
import { ReadOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { useFeatureFlag, useSonarObjectReference } from '@hooks';
export const GoToDictionaryButton = ({ sonarObjectId }) => {
    const isEnabled = useFeatureFlag(FeatureFlag.DataDictionary);
    const { displayName } = useSonarObjectReference(sonarObjectId !== null && sonarObjectId !== void 0 ? sonarObjectId : 0);
    if (!isEnabled || !sonarObjectId) {
        return null;
    }
    return (React.createElement(Link, { to: `${FULL_ROUTES.DATA_DICTIONARY}?${getQueryString({
            displayName,
            sonarObjectId
        })}` },
        React.createElement(Button, { className: 'go-to-dictionary-button', icon: React.createElement(ReadOutlined, null), type: 'primary' }, COPY_SPECIFIC.GO_TO_DICTIONARY)));
};
